import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./contexts/AuthContext";
import { CatalogProvider } from "./contexts/CatalogContext";
import { PlaybackProvider } from "./contexts/PlaybackContext";
import { ErrorBoundary } from "./components/ErrorBoundary";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <CatalogProvider>
          <PlaybackProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </PlaybackProvider>
        </CatalogProvider>
      </AuthProvider>
    </ErrorBoundary>
  </StrictMode>
);

window.addEventListener("load", () => {
  import("virtual:pwa-register")
    .then(({ registerSW }) => registerSW({ immediate: true }))
    .catch((err) => console.warn("[8K Brainzr] SW register failed:", err));

  // When a new service worker takes control (skipWaiting + clientsClaim do
  // their job), the JS that was already loaded in the page keeps running —
  // which is how users end up on stale bundles after a deploy. Force a
  // single reload so the new SW serves the latest index.html + JS.
  if ("serviceWorker" in navigator) {
    let refreshing = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  }
});
